import { CalendarOutlined } from '@ant-design/icons'
import { Button, Card, Col, Divider, Row, Space, Typography } from 'antd'
import React, { FC, ReactElement } from 'react'

import { MESSAGES } from './constants'
import { AppointmentCardProps, NotaryProps } from './types'
import styles from './styles.module.scss'

const PastEventTag: FC = () => <span className={styles.pastEventTag}>{MESSAGES.PAST_EVENT}</span>

const NotaryAvatar: FC<{ notary: NotaryProps }> = ({ notary }) => (
  <div className={styles.avatar}>
    {notary.hasPhoto ? (
      <img src={notary.photoUrl ?? ''} alt={notary.name} className={styles.avatarImg} />
    ) : (
      <div className={styles.avatarPlaceholder}>{notary.initials}</div>
    )}
  </div>
)

export const AppointmentCard: FC<AppointmentCardProps> = ({
  appointmentDatetime,
  isPastEvent,
  locationText,
  hasCoSigners,
  isHybrid,
  isRonEligible,
  addCosignerPath,
  joinSessionPath,
  notary,
  attendingSentence,
  signingAgentTitle
}): ReactElement => {
  const appointmentSet = !!appointmentDatetime

  return (
    <Card>
      <Row justify="space-between" align="middle">
        <Space>
          <Typography.Text type="secondary">
            <CalendarOutlined className={styles.icon} />
          </Typography.Text>
          <Typography.Title level={4} className={styles.title}>
            {appointmentSet ? appointmentDatetime : MESSAGES.APPOINTMENT_NOT_SET}
          </Typography.Title>
          {isPastEvent && <PastEventTag />}
        </Space>
        {!isHybrid && !hasCoSigners && !isRonEligible && (
          <Button href={addCosignerPath} data-remote="true">
            {MESSAGES.ADD_CO_SIGNER}
          </Button>
        )}
      </Row>

      {appointmentSet ? (
        <Typography.Text className={styles.locationText}>{locationText}</Typography.Text>
      ) : (
        <Typography.Text type="secondary">{MESSAGES.APPOINTMENT_NOT_SET_SOON}</Typography.Text>
      )}

      {joinSessionPath && (
        <Button
          type="primary"
          className={styles.joinSessionButton}
          href={joinSessionPath}
          target="_blank"
          rel="noopener"
        >
          {MESSAGES.JOIN_SIGNING_SESSION}
        </Button>
      )}

      {notary ? (
        <>
          <Divider className={styles.divider} />
          <Typography.Text className={styles.bodyText}>{attendingSentence}</Typography.Text>
          <Row align="middle" wrap={false} className={styles.notaryRow}>
            <Col flex="none" className={styles.notaryPhoto}>
              <NotaryAvatar notary={notary} />
            </Col>
            <Col flex="auto">
              <Space direction="vertical" size={0}>
                <Typography.Text strong className={styles.notaryName}>
                  {notary.name}
                </Typography.Text>
                {notary.phone && <Typography.Text className={styles.bodyText}>{notary.phone}</Typography.Text>}
              </Space>
            </Col>
          </Row>
        </>
      ) : (
        <Typography.Paragraph type="secondary">
          Your {signingAgentTitle} {MESSAGES.NOTARY_NOT_ASSIGNED}
        </Typography.Paragraph>
      )}
    </Card>
  )
}

export default AppointmentCard
